export default __webpack_public_path__ + "static/media/community-disabled.6aa50ce7.png";